module.exports = __webpack_public_path__ + "static/img/Bachelor_010295.599dbc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010295.jpg
// module id = 142
// module chunks = 0